
<template>
   <div class="scope-of-use">
        <div v-if="modalType === 'edit'" class="dname">
          {{name}}
        </div>
        <template v-if="modalType === 'new' || updateScopeStatus === true">
          <scope-shop v-if="type === 'shop'" @shop="onChange" :deduct_category_id="deduct_category_id"/>
          <scope-category v-if="type === 'fresh_category'" @category="onChange" :deduct_category_id="deduct_category_id"/>
          <scope-product v-if="type === 'fresh_product'" @product="onChange" :deduct_category_id="deduct_category_id"/>
        </template>
        <el-button style="margin-left: 6px;" v-if="modalType !== 'new' && type !== 'shop'" type="primary" @click="updateScopeStatus = !updateScopeStatus">{{ updateScopeStatus ? $t('pages_birthday_discount_index_209'): $t('pages_deduct_coupon_rule_components_scopeofuse_index_449') }}</el-button>
   </div>
</template>

<script>
import i18n from '../../../../locales/index'

import ScopeShop from './shop'
import ScopeCategory from './category'
import ScopeProduct from './product'

export default {
  name: 'ScopeOfUse',
  model: {
    prop: 'deduct_category_id',
    event: 'change'
  },
  components: {
    ScopeShop,
    ScopeCategory,
    ScopeProduct
  },
  props: {
    type: {
      type: String,
      default: 'shop'
    },
    deduct_category_id: Number,
    modalType: String,
    name: String
  },
  data () {
    return {
      updateScopeStatus: false,
    }
  },
  methods: {
    onChange (data) {
      this.$emit('change', data.value)
      this.$emit('changeName', data.name)
    }
  }
}
</script>

<style lang='scss' scoped>
.scope-of-use{
  display: flex;
  .dname{
    margin-right: 6px;
  }
}
</style>
